import AccountDetailRow from "./AccountDetailRow";

const AccountDetails = ({
	accountKeys,
	accountDetail,
	onCopy,
	lables
}) => {
	return (
		<>
			{accountKeys.map((key) => {
				if (!lables[key] || !accountDetail[key]) {
					return null;
				}

				return (
					<AccountDetailRow
						key={key}
						label={lables[key]}
						value={accountDetail[key]}
						branchName={accountDetail?.branch_name}
						showBranchTag={key === "bankName"}
						onCopy={onCopy}
					/>
				);
			})}
		</>
	);
};

export default AccountDetails;